import React from "react";
import { MessageCircle } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function HeroDesign() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="hero-design" className="relative w-full min-h-screen flex items-center justify-center overflow-hidden bg-background">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1561763/img/modern_night_house_warm_lighting.png)] bg-cover bg-center bg-no-repeat brightness-90" />
        <div className="absolute inset-0 bg-[#576192]/10" />
      </div>

      {}
      <div ref={ref} className={`relative z-10 container mx-auto px-4 md:px-8 flex flex-col items-center text-center pt-12 transition-all duration-500 ease-out delay-200 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
        <h1 className="font-bold text-5xl tracking-tighter mb-6 leading-tight drop-shadow-sm text-white md:text-7xl lg:text-8xl">
          Sicurezza. Comfort. Design.
        </h1>
        
        <p className="text-white text-lg md:text-2xl font-medium mb-10 max-w-2xl mx-auto leading-relaxed opacity-90 whitespace-normal md:whitespace-nowrap [text-shadow:0_1px_2px_#NaN0000]">
          Soluzioni su misura che uniscono funzionalità e stile per la tua casa.
        </p>

        <Button asChild className="bg-[#576192] hover:bg-[#454d75] text-white rounded-full px-10 py-8 text-lg font-semibold shadow-xl hover:shadow-2xl transition-all duration-300 hover:scale-105 border-none ring-offset-2 focus-visible:ring-2 ring-[#576192]">
          <Link to="https://wa.me/393349255303" newTab className="inline-flex items-center justify-center gap-2 whitespace-nowrap [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 aria-invalid:border-destructive h-9 has-[>svg]:px-3 text-white rounded-full px-10 py-8 text-lg font-semibold shadow-xl transition-all duration-300 border-none ring-offset-2 focus-visible:ring-2 ring-[#576192] !bg-[hsl(228,33%,46%)] disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:bg-[#454d75] hover:shadow-2xl hover:scale-105">
            <MessageCircle className="mr-2 h-6 w-6" />
            Contattaci su WhatsApp
          </Link>
        </Button>
      </div>
    </section>;
}